var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-stage',{ref:"stage",attrs:{"config":_vm.stageSize},on:{"mousedown":_vm.handleStageMouseDown}},[_c('v-layer',{ref:"layer"},[_vm._l((_vm.images),function(item){return _c('v-image',{key:item.id,attrs:{"config":{
          image: item.image,
          name: item.name,
          x: item.x,
          y: item.y,
          width: item.width,
          height: item.height,
          draggable: item.draggable
        }}})}),_c('v-transformer',{ref:"transformer"})],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }